module.exports = new __parcel__URL__("shrimp.116d9eea.svg").toString();